<!-- 
Dialog for deleting a risk factor range.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog xs">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Delete risk factor range</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="state.processing"/>
      <v-card-text>Are you sure you want to delete this risk factor range?</v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.processing" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.processing" flat color="error" @click="deleteRiskFactor">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
    <our-validation-dialog v-model="showValidationDialog" :state-error="state.error" />
  </v-dialog>
</template>

<script>
import * as action from "@/store/levy-collection-risk-factors/action-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      validator: prop => typeof prop === "number" || prop === null,
      required: true
    },
    riskFactorId: {
      validator: prop => typeof prop === "number" || prop == null,
      default: null
    }
  },
  data() {
    return {
      showValidationDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollectionRiskFactors.delete;
    }
  },
  methods: {
    async deleteRiskFactor() {
      const d = {
        levyCollectionId: this.levyCollectionId,
        riskFactorId: this.riskFactorId
      };
      const deleted = await this.$store.dispatch(action.DELETE, d);
      this.hide();
      if (!deleted) {
        this.showValidationDialog = true;
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
